import { Component, OnInit } from '@angular/core';
import { LessonCardHomePageComponent } from '../lesson-card-home-page/lesson-card-home-page.component';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Continuing Home Page Card',
  key: 'continuingHomePageCard',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.CourseLesson,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-continuing-home-page-card',
  templateUrl: './continuing-home-page-card.component.html',
  styleUrls: ['./continuing-home-page-card.component.scss']
})
export class ContinuingHomePageCardComponent extends LessonCardHomePageComponent {

  imageWidth = 545;
  imageHeight = 308;

  getLessonUrl() {

    //this.data.CourseLessonProgressPercentComplete
    return this.courseRepositoryService.getLessonImageUrl(this.data, this.imageWidth, this.imageHeight);
  }
}
